import { useEffect, useRef } from 'react';
import noop from '../utils/noop';

const useTimeout = (callback: () => void, delay: number | null) => {
	const callbackRef = useRef<() => void>();

	useEffect(() => {
		callbackRef.current = callback;
	}, [callback]);

	useEffect(() => {
		if (!delay) {
			return noop;
		}

		const timeoutID = setTimeout(() => {
			callbackRef.current && callbackRef.current();
		}, delay);

		return () => clearInterval(timeoutID);
	}, [delay]);
};

export default useTimeout;
